import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Prompt } from 'react-router-dom';
import { routerWillLeave } from '@actions/confirmation-actions';

/**
 * FormPrompt component - renders a navigation warning when form is modified.
 * Uses Redux to check the discard state.
 *
 * @returns {React.Element} The Prompt component
 */
const FormPrompt = ({ modified }) => {
  const discard = useSelector(state => state.confirmation.discard);

  return (
    <Prompt when={modified && !discard} message={routerWillLeave} />
  );
};

FormPrompt.propTypes = {
  modified: PropTypes.bool
};

export default FormPrompt;
